import { useState } from "react";

const usePut = <T>(url: string) => {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const put = async (payload: object | FormData) => {
    setLoading(true);
    setError(null);

    try {
      const isFormData = payload instanceof FormData;

      const response = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
        method: "PUT",
        headers: isFormData ? undefined : { "Content-Type": "application/json" },
        body: isFormData ? payload : JSON.stringify(payload),
      });

      if (!response.ok) {
        let errorMessage = `HTTP error! status: ${response.status}`;
        try {
          const errorBody = await response.json();
          if (errorBody?.message) errorMessage = errorBody.message;
        } catch (_) {}
        throw new Error(errorMessage);
      }

      const result = await response.json();
      setData(result as T);
      return result as T;
    } catch (err) {
      setError(err as Error);
      throw err; // re-throw so the caller's catch block triggers
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, put };
};

export default usePut;
